export default {
  label: {
    saveTooltip: 'Guardar',
    cancelTooltip: 'Cancelar',
  },
};
